import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './Dashboard';

import CacheBuster from 'react-cache-buster';
import packageFile from '../package.json';
import CacheLoading from './CacheLoading';

import SignUpForm from './Signup-new';
import Login from './Login';
import TutorFeedbackPage from './TutorFeedbackPage'; 
import StudentEngagement from './StudentEngagement';
import PresentationPage from './talkTreeShared/PresentationGeneration/PresentationPage';
import TalkTreeResources from './talkTreeShared/PresentationGeneration/TalkTreeResources';

function App() {
  const isProduction = process.env.NODE_ENV === 'production';
  const {version} = packageFile;

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} // If false, the library is disabled.
      isVerboseMode={false} // If true, the library writes verbose logs to console.
      loadingComponent={<CacheLoading />} // If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} // If public assets are hosted somewhere other than root on your server.
    >
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/signup" exact element={<SignUpForm />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/" element={<Login />} />
            <Route path="/TutorFeedback" element={<TutorFeedbackPage />} />
            <Route path="/StudentEngagement" element={<StudentEngagement />} />
            <Route path="/Presentation" element={<PresentationPage />} />
            <Route path="/TalkTreeResources" element={<TalkTreeResources/>} />
          </Routes>
        </BrowserRouter>
      </div>
    </CacheBuster>
  );
}

export default App;